import React from "react";
import { REQ_ERR_MSG } from "../../Shared/Helper/ValidationMessage";
interface formRadioProps {
  register: any;
  errors?: any;
  className: string;
  tabIndex?: number;
  name: string;
  radioId: string;
  labelName: string;
  required?: boolean;
  defaultChecked?: boolean;
  onClick?: () => void;
  value: boolean | string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void; 
  isLabelClass?:boolean;
  labelClass?:string;
}
export default function FormRadioButton(props: formRadioProps) {
  const {
    tabIndex,
    register,
    required,
    labelName,
    className,
    name,
    radioId,
    defaultChecked,
    onClick,
    value,
    onKeyDown,
    isLabelClass,
    labelClass,
  } = props;

  return (
    <>
      <div className={className}>
        <input
          className="form-check-input mb-2 cursor-pointer"
          type="radio"
          id={radioId}
          tabIndex={tabIndex}
          value={value.toString()}
          {...register(name, {
            ...(required && {
              required: {
                value: true,
                message: REQ_ERR_MSG,
              },
            }),
          })}
          defaultChecked={defaultChecked}
          onClick={onClick}
          onKeyDown={onKeyDown}
        />
        {/* <label className="form-check-label mx-2" htmlFor={radioId}> */}
        <label className={isLabelClass === true?labelClass:"form-check-label mx-2"} htmlFor={radioId}>
          {labelName}
        </label>
      </div>
    </>
  );
}
